import React from "react";
import ReactDOM from "react-dom";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

import HexModal from "../../app/components/modals/HexModal";
import { hideModal } from "../commons/hide-modal";
import { showErrorMessage } from "../commons/show-error-message";
import ActionConfirmationModal from "../../app/components/modals/ActionConfirmationModal";
import { rejectEducation } from "./reject-education";

function renderRejectFinancialRequest({ requestId }) {
  const target = document.getElementById("table-request-education-container");
  if (target) {
    ReactDOM.render(
      <HexModal>
        <ActionConfirmationModal
          message={translate("request-section.rejected-financial-message")}
          actionName={translate("request-section.deny-course")}
          cantBeReverted
          callback={() => {
            rejectEducation(requestId);
            hideModal();
          }}
        />
      </HexModal>,
      document.getElementById("modal-container")
    );
  }
}

export async function displayRejectFinancialRequest(requestId, amount) {
  try {
    renderRejectFinancialRequest({ requestId, amount });
    addContextLog("info", "displayRejectFinancialRequest", "display-screen", {
      requestId,
      amount,
    });
  } catch (e) {
    logError(
      e,
      `Error to displayRejectFinancialRequest in request ${requestId}`
    );
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
